import { DateTime } from 'luxon'
import Image from './Image'

export default class Entry {
    constructor({id, date, lonlat, waypoint, title = '', content = '', images = [], coverImage, inline = false, showHeading = true } = {}) {
        this.id = id
        this.title = title
        this.waypoint = waypoint

        // TODO: use `when` for consistency with Waypoint?
        this.setDate(DateTime.fromISO(date))

        // TODO: use Stop latlng as default?
        this.lonlat = lonlat
        this.lat = lonlat ? lonlat[1] : null
        this.lng = lonlat ? lonlat[0] : null
        this.latlng = lonlat ? [this.lat, this.lng] : null

        this.content = content
        this.images = images
        this.coverImage = coverImage || images[0] || null
        this.display = { inline, showHeading }
    }

    atPosition(latlng) {
        return this.latlng
          && this.lat === latlng[0]
          && this.lng === latlng[1]
    }

    setDate(date) {
        if (date && date.isValid) {
            this.date = date
            this.isoDate = this.date.toISODate()
            this.localDate = this.date.toLocaleString(DateTime.DATE_MED)
            this.localShortDate = this.date.toLocaleString(DateTime.DATE_SHORT)
        } else {
            this.date = null
            this.isoDate = this.localDate = this.localShortDate = ''
        }
    }

    attachWaypoint(waypoint) {
        this.waypoint = waypoint
    }

    contentPreview(targetLength = 80) {
        if (!this.content) return ''
        if (this.content.length <= targetLength) return this.content
        return this.content.substr(0, targetLength - 2) + '...'
    }

    static fromJson(json) {
        let images = json.images ? json.images.map(image => Image.fromJson(image)) : []

        const entryArgs = {
            id: json.id,
            date: json.date,
            title: json.title,
            content: json.content,
            coverImage: images.find(image => image.id === json.coverImage),
            lonlat: json.lonlat,
            inline: json.inline,
            showHeading: json.showHeading,
            images
        }

        return new Entry(entryArgs)
    }
}
